import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
    {
      path: '/',
      name: 'Home',
      // component: Home
      component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    },
    {
      path: '/encuesta/:e',
      name: 'Poll',
      component: () => import(/* webpackChunkName: "about" */ '../views/Poll.vue'),
      props: true
    },
    {
      path: '/:any?',
      name: 'Home',
      component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    },
    {
      path: '/pdf/:any?',
      name: 'pdf',
      component: () => import(/* webpackChunkName: "NotFound" */ '../views/Pdf.vue')
    },
    {
      path: '/404',
      name: 'not-found',
      component: () => import(/* webpackChunkName: "NotFound" */ '../views/PageNotFound.vue')
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: () => import(/* webpackChunkName: "NotFound" */ '../views/PageNotFound.vue')
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
